module.exports = __webpack_public_path__ + "img/150h100_obe_poloviny_povorotno_otkidnye.e74283a0.svg";